import axios from "axios";
import { useEffect, useLayoutEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Estate } from "../../types/estate";
import "./estates.scss";
import { gsap } from "gsap-trial";
import { cleanSlug, fetchImageData } from "../../helpers/helpers";

const Estates = () => {
    const { slug } = useParams();
    const [estate, setEstate] = useState<Estate | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [images, setImages] = useState<string[][]>([]);
    const [heroVideo, setHeroVideo] = useState<string | undefined>();

    useEffect(() => {
        window.scrollTo(0, 0);
        const fetchArticle = async () => {
            try {
                const response = await axios.get(
                    `https://wp.sirendigital.uk/space-industrial/wp-json/wp/v2/posts?_embed&slug=${slug}`
                );
                if (response.data.length > 0) {
                    setEstate(response.data[0]);
                } else {
                    setError("Article not found");
                }
            } catch (err) {
                setError("Failed to load article");
            } finally {
                setLoading(false);
            }
        };

        fetchArticle();
    }, [slug]);

    // useEffect(() => {
    //     const timeline = gsap.timeline({});
    //     timeline
    //         .fromTo(
    //             ".opacity-anim",
    //             { opacity: 0 },
    //             { opacity: 1, duration: 1, ease: "power2.out" },
    //             "<"
    //         )
    //         .fromTo(
    //             ".estate-featured",
    //             { clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)" },
    //             {
    //                 clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
    //                 duration: 1.5,
    //                 ease: "power2.out",
    //             },
    //             "<"
    //         );
    //     // const fetchImages = async () => {
    //     //     console.log(estate);
    //     //     if (estate) {
    //     //         if (estate.acf.video) {
    //     //             fetchImageData(estate.acf.video).then((video) => {
    //     //                 setHeroVideo(video);
    //     //             });
    //     //         }
    //     //         const imagePromises = estate.acf.units?.map((unit, index) =>
    //     //             unit.images.map((image) => fetchImageData(image.image))
    //     //         );
    //     //         if (imagePromises) {
    //     //             const resolvedImages = await Promise.all(
    //     //                 imagePromises.map((promises) => Promise.all(promises))
    //     //             );
    //     //             setImages(resolvedImages);
    //     //             console.log(resolvedImages);
    //     //         }
    //     //     }
    //     // };
    //     // fetchImages();
    // }, [estate]);

    return (
        <div className="contain-wrapper">
            <div className="estate-hero contain">
                <div className="estate-one opacity-anim">
                    <div className="wrapper">
                        <p>
                            Home / <span className="volt">Estate</span>
                        </p>
                    </div>
                    <div className="second-wrapper">
                        {estate?.acf.map_location && (
                            <Link
                                target="_top"
                                to={`/map?lat=${estate?.acf.map_location[0].lat}&lng=${estate?.acf.map_location[0].long}&estate=${estate?.slug}`}
                                state={{ zoom: 11 }}
                                className="volt-button"
                            >
                                <p>View on the map</p>
                            </Link>
                        )}
                        <Link
                            target="_top"
                            className="volt-button"
                            to={"/portfolio"}
                        >
                            <p>Back</p>
                        </Link>
                    </div>
                </div>
                {estate && (
                    <>
                        <div className="estate-two">
                            <div className="title-wrapper opacity-anim">
                                <img
                                    src="../ui/logo.svg"
                                    className="logo"
                                    alt="logo"
                                />
                                <h1>{estate.acf?.name}</h1>
                            </div>
                            <h3 className="excerpt opacity-anim">
                                {estate.acf?.excerpt}
                            </h3>
                            <div className="estate-featured">
                                {estate.acf.video ? (
                                    <div className="estate-featured-video estate-featured">
                                        <video
                                            muted
                                            src={estate.acf.video}
                                            controls
                                            autoPlay
                                            loop
                                            playsInline
                                            poster={
                                                estate.acf.image ||
                                                estate._embedded[
                                                    "wp:featuredmedia"
                                                ][0].source_url
                                            }
                                        ></video>
                                    </div>
                                ) : (
                                    <img
                                        className="estate-featured-image estate-featured"
                                        src={
                                            estate.acf.image ||
                                            estate._embedded[
                                                "wp:featuredmedia"
                                            ][0].source_url
                                        }
                                    />
                                )}
                            </div>
                            <div className="summary">
                                <p className="volt">In Summary</p>
                                <div className="summary_points">
                                    {estate.acf.summary_points?.map(
                                        (point, index) => {
                                            return (
                                                <div
                                                    className="point"
                                                    key={index}
                                                >
                                                    <h3>{point.summary}</h3>
                                                </div>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                            <div className="checklist">
                                {estate.acf.checklist_points && (
                                    <p className="volt">Checklist</p>
                                )}
                                <div className="checklist_points">
                                    {estate.acf.checklist_points?.map(
                                        (point, index) => {
                                            return (
                                                <div
                                                    className="point"
                                                    key={index}
                                                >
                                                    <img
                                                        src="../ui/check.svg"
                                                        alt="check"
                                                    />
                                                    <h3>{point.checklist}</h3>
                                                </div>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                            <div className="location">
                                {estate.acf.map_location && (
                                    <>
                                        <p className="volt">Location</p>
                                        <div className="location-content">
                                            <div>
                                                <Link
                                                    target="_top"
                                                    to={`/map?lat=${estate?.acf.map_location[0].lat}&lng=${estate?.acf.map_location[0].long}`}
                                                >
                                                    <p className="volt">
                                                        View on the map
                                                    </p>
                                                </Link>
                                            </div>
                                            <h3>{estate.acf?.location}</h3>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className="estate-three">
                            {estate.acf.units && <h1>Units on the estate</h1>}
                            <div className="unit-grid">
                                {estate.acf.units &&
                                    estate.acf.units.map((unit, index) => {
                                        if (unit.preview) {
                                            return null;
                                        }
                                        if (unit.spotlight) {
                                            return (
                                                <Link
                                                    target="_top"
                                                    to={`/portfolio/${slug}/${cleanSlug(
                                                        unit.name
                                                    )}`}
                                                    className="spotlight-wrapper"
                                                    key={index}
                                                >
                                                    <div
                                                        className={
                                                            unit.let_status
                                                        }
                                                    >
                                                        <p>{unit.let_status}</p>
                                                    </div>
                                                    <div
                                                        style={{
                                                            backgroundImage: `url(${unit.images[0].image})`,
                                                        }}
                                                        className={`spotlight`}
                                                    ></div>
                                                    <div className="unit-content">
                                                        <div className="wrapper">
                                                            <h2>{unit.name}</h2>
                                                            <h3 className="volt">
                                                                {unit.sq_ft}
                                                            </h3>
                                                            <h3>
                                                                {unit.postcode}
                                                            </h3>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                <p>
                                                                    {
                                                                        unit.unit_type
                                                                    }
                                                                </p>
                                                                <p className="volt">
                                                                    {
                                                                        unit.let_status
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="wrapper">
                                                            <div
                                                                className="wysiwyg"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: unit.description,
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </Link>
                                            );
                                        } else {
                                            return (
                                                <Link
                                                    target="_top"
                                                    to={`/portfolio/${slug}/${cleanSlug(
                                                        unit.name
                                                    )}`}
                                                    style={{
                                                        backgroundImage: `url(${unit.images[0].image})`,
                                                    }}
                                                    className={`unit`}
                                                    key={index}
                                                >
                                                    <div
                                                        className={
                                                            unit.let_status
                                                        }
                                                    >
                                                        <p>{unit.let_status}</p>
                                                    </div>
                                                    <div className="unit-content">
                                                        <div className="wrapper">
                                                            <img
                                                                src="../ui/logo.svg"
                                                                alt="logo"
                                                                className="logo"
                                                            />
                                                            <h3>{unit.name}</h3>
                                                        </div>
                                                        <div className="wrapper">
                                                            <h4>
                                                                {unit.postcode}
                                                            </h4>
                                                            <h4 className="volt">
                                                                /
                                                            </h4>
                                                            <h4>
                                                                {unit.sq_ft}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </Link>
                                            );
                                        }
                                    })}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Estates;
